import { HasKind } from '@/utilities/HasKind';

import { Crumbs } from '../../bakery/Crumbs';
import { crumble as crumbleReplication, Replication } from '../../Replication';

export const kind = 'ActivateComplete';

export interface ActivateComplete extends HasKind<typeof kind> {
  replication: Replication;
}

export function crumble(action: ActivateComplete): Crumbs {
  return {
    replication: crumbleReplication(action.replication),
  };
}
